import { Checkbox } from "antd";
import React from "react";
import { FC } from "react";
import { ReactSVG } from "react-svg";



export const DeleteQuestionareButton: FC<{onClick}> = ({onClick})=>{
    return (
     <a key="list-loadmore-edit"><ReactSVG
     className="sz-18 action-buttons"
     src="/images/delete-icon.svg"
     title="Delete Question"
     onClick={onClick}
   /></a>
    )
 };
 
 export const AddQuestionareButton: FC<{onClick}> = ({onClick})=>{
   return (   
     <a key="list-loadmore-edit"><ReactSVG
   className="sz-18 action-buttons"
   src="/images/add-icon.svg"
   title="Add Question"
   onClick={onClick}
 /></a>

 )
 };
 
 export const CopyQuestionareButton: FC<{onClick}> = ({onClick})=>{
   return (<a key="list-loadmore-edit"><ReactSVG
   className="sz-15 action-buttons"
   src="/images/copy-icon.svg"
   title="Copy Question"
   onClick={onClick}
 /></a>)
 };
 
 export const EditQuestionaireButton: FC<{onClick}> = ({onClick})=>{
   return (<a key="list-loadmore-edit"><ReactSVG
   className="sz-12 action-buttons"
   src="/images/edit-icon.svg"
   title="Edit Question"
   onClick={onClick}
 /></a>)
 };

 export const EditQuestionaireCheckboxButton: FC<{onClick}> = ({onClick})=>{
  return (
    <Checkbox  
    className="sz-12 action-buttons ml-3"
    checked={true} 
    defaultChecked={false} 
    onChange={onClick}
    >
      </Checkbox>
    )
 };